import { useSelector } from "react-redux";

const AbandonedCart = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/2e805665-274e-4bbb-bff6-fb419e931b01`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default AbandonedCart;
  